import { QueryOptions, useQuery } from 'react-query';
import { getJustifiProcessor } from '../';
import { GetLocationProcessorResponse } from '@weave/schema-gen-ts/dist/schemas/payments-platform/payments-config/payments_config.pb';

export const usePaymentsConfig = (
  locationId: string | undefined,
  options: QueryOptions<GetLocationProcessorResponse> = {}
) => {
  const isQueryEnabled = 'enabled' in options ? !!options.enabled : true;
  const { data, ...queryResult } = useQuery(
    [locationId, 'payments-config'],
    () => getJustifiProcessor({ locationId: locationId! }),
    { ...options, enabled: !!locationId && isQueryEnabled }
  );

  return { ...data, data, ...queryResult };
};
